export default __webpack_public_path__ + "static/thumb-2-d6cee318204f3a2b1edc9d62ef421e8b.jpg";